export default "__VITE_ASSET__DrUPAJSw__"